import { atom } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils';

import { STORAGE_KEYS } from '@/atoms/storageKeys';

/**
 * Stores scroll positions per key.
 * Key: string identifier (e.g., 'my-plans', 'manage-plans')
 * Value: number (y-position)
 *
 * Uses atomWithStorage to persist scroll positions across Okta token refreshes.
 */
export const scrollPositionsAtom = atomWithStorage<Record<string, number>>(
  STORAGE_KEYS.SCROLL_POSITIONS,
  {},
);

/**
 * Resets all scroll positions.
 * Call this from the layout's unmount cleanup.
 */
export const resetAllScrollAtom = atom(null, (_get, set) => {
  set(scrollPositionsAtom, RESET);
});

export { RESET };
